import InsurerReportingsService from "@/api/services/insurerReportings";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    totalCommissionsAmountDueToInsurer: () => (insurerReportings) => {
      const total = insurerReportings
        .filter((insurerReporting) => insurerReporting.commissionsPaymentStatus === "pending")
        .reduce((sum, insurerReporting) => sum + (insurerReporting.commissionsAmountDueToInsurer || 0), 0);

      return Math.round(total * 100) / 100;
    },
    totalClaimsAmountDueToEstaly: () => (insurerReportings) => {
      const total = insurerReportings
        .filter((insurerReporting) => insurerReporting.claimsPaymentStatus === "pending")
        .reduce((sum, insurerReporting) => sum + (insurerReporting.claimsAmountDueToEstaly || 0), 0);

      return Math.round(total * 100) / 100;
    },
    getCommissionPaymentStatuses: () => () => {
      return ["pending", "paid"];
    },
    getClaimsPaymentStatuses: () => () => {
      return ["pending", "paid"];
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex(
      { commit },
      {
        page = 1,
        perPage = null,
        insurers = [],
        insurerContractGroupReferences = [],
        commissionsPaymentStatus = [],
        claimsPaymentStatus = [],
        startDate = null,
        endDate = null,
        save = true,
      } = {},
    ) {
      const response = await InsurerReportingsService.fetchIndex({
        page,
        perPage,
        insurers,
        insurerContractGroupReferences,
        commissionsPaymentStatus,
        claimsPaymentStatus,
        startDate,
        endDate,
      });
      if (!response?.success) return response;

      if (save) {
        const { data } = response;
        commit("setIndex", toCamelCase(data));
      }

      return response;
    },

    async updateInsurerReporting(_, { id, data }) {
      return InsurerReportingsService.update(id, data);
    },

    downloadQontoBulkTransferCSV(_, { periods }) {
      return InsurerReportingsService.downloadQontoBulkTransferCSV({ periods });
    },
  },
};
